export const expertSearchKey = {
    useGetExpertList: "expertSearchKey.query.useGetExpertList",
};
